import React, { useState } from 'react';
import { inject, observer } from 'mobx-react';
import { FormattedMessage } from 'react-intl';

import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import InfoPageModal from '../../info-page/InfoPageModal';
import ButtonLink from '../../common/ButtonLink';

const TermsOfDeliveryStatementLink = ({ configStore, children }) => {
  const [show, setShow] = useState(false);

  const toggle = () => {
    setShow(!show);
  };

  return (
    <>
      {children ? (
        <ButtonLink className="TermsOfUseStatementLink" onClick={toggle}>
          {children}
        </ButtonLink>
      ) : (
        <FormattedMessage
          id="termsOfDeliveryStatement.termsOfDelivery"
          defaultMessage="{termsOfDelivery}"
          values={{
            termsOfDelivery: (
              <ButtonLink className="TermsOfDeliveryStatementLink" onClick={toggle}>
                <FormattedMessage
                  id="termsOfDeliveryStatement.termsOfDeliveryLink"
                  defaultMessage="terms of delivery"
                />
              </ButtonLink>
            ),
          }}
        />
      )}
      {configStore.termsOfDeliveryStatement.infoPageId && show && (
        <InfoPageModal
          isOpen={show}
          toggle={toggle}
          pageId={configStore.termsOfDeliveryStatement.infoPageId}
        />
      )}
    </>
  );
};

TermsOfDeliveryStatementLink.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
};

export default inject('configStore')(observer(TermsOfDeliveryStatementLink));
